import { CreateFileParams, FileParams } from "@/types/fileTypes";

export enum ProductPageContentType {
  TEXT = 'text',
  VIDEO = 'video',
  IMAGE = 'image',
}

export const PRODUCT_PAGE_CONTENT_FILE_TYPES = [
  ProductPageContentType.VIDEO,
  ProductPageContentType.IMAGE,
];

export interface ProductPageContentParams {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  type: ProductPageContentType;
  productPageSectionId: string;
  title?: string;
  description?: string;
  position: number;
  file?: FileParams;
}

export interface ProductPageContentData {
  id: string;
  createdAt?: string;
  updatedAt?: string;
  type: ProductPageContentType;
  productPageSectionId: string;
  title?: string;
  description?: string;
  position: number;
  file?: FileParams;
}

export type ProductPageContentCreateData = Omit<ProductPageContentData, 'id' | 'createdAt' | 'updatedAt' | 'file'> & {
  file?: Omit<CreateFileParams, 'subjectId' | 'subjectType'>;
};
